import React from 'react';
import PropTypes from 'prop-types';
import { wrapper } from '@redux/store';
import { appSetPageData } from '@redux/actions/app';
import HomeTime, { getHomeTimeProps } from '@components/pages/home-time/homeTime';
import getGraphQLServerClient from '@graphql/serverClient';
import indexQuery from '@graphql/queries/indexQuery';

const IndexPage = ({ page = '1', ...data }) => {
  return <HomeTime data={data} page={page} />;
};

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ req, locale, query }) => {
      const NEXT_PUBLIC_JSON_API_PATH = process.env.NEXT_PUBLIC_JSON_API_PATH;
      let props = null;
      const client = getGraphQLServerClient();
      const nonce = req.headers['x-nonce'] || '';

      const pageQ = await client.request(indexQuery, {
        slug: 'home',
        site: `futurium${locale?.toUpperCase()}` || 'futuriumDE'
      });
      const baseData = await getHomeTimeProps({
        query,
        locale,
        uri: 'index',
        NEXT_PUBLIC_JSON_API_PATH
      });
      const currentInfo = await getHomeTimeProps({
        query,
        locale,
        uri: 'currentInfo',
        NEXT_PUBLIC_JSON_API_PATH
      });
      const eventsData = await getHomeTimeProps({
        query,
        locale,
        uri: 'eventTeaser',
        NEXT_PUBLIC_JSON_API_PATH
      });

      props = {
        ...baseData,
        currentInfoModule: {
          ...currentInfo
        },
        events: {
          ...eventsData
        },
        graphql: {
          ...pageQ
        },
        nonce
      };

      await store.dispatch(appSetPageData(props));

      return {
        props,
        notFound: !props?.PAGE_TYPE || !!props?.error
      };
    }
);

IndexPage.propTypes = {
  data: PropTypes.shape().isRequired,
  page: PropTypes.string
};

export default IndexPage;
